import Callout from '@passkeys/ui/callout';
import Frame from '@passkeys/ui/frame';
import Icon from '@passkeys/ui/icon';
import Logo from '@passkeys/ui/logo';
import Text from '@passkeys/ui/text';
import React from 'react';

import exodus from '@/ui/exodus';
import { cn } from '@/ui/utils/classnames';
import { getMobileOS, MobileOS } from '@/ui/utils/navigator';

const closeCallout = () => {
  exodus.pwa.hideInstallCallout();
};

const IosInstructions = () => (
  <>
    Tap the <span className="text-[#387CF6]">share icon</span> and choose{' '}
    <span className="underline">Add to Home Screen</span>.
  </>
);

const AndroidInstructions = () => (
  <>
    Tap the three-dot icon and select{' '}
    <span className="underline">Add to Home Screen</span>.
  </>
);

const instructionsByOs = {
  [MobileOS.Ios]: IosInstructions,
  [MobileOS.Android]: AndroidInstructions,
};

function AppIcon({ className }: { className?: string }) {
  return (
    <Frame
      size={48}
      shape="squared"
      className={cn(className, 'before:hidden after:bg-pink-500')}
    >
      <Logo />
      <div className="absolute bottom-0 right-0 -mb-1 -mr-1 flex size-5 items-center justify-center rounded-full bg-black theme-dark:bg-white">
        <Icon
          size={10}
          className={cn('ui-text-white theme-dark:ui-text-black')}
          name="arrow-down-to-line"
        />
      </div>
    </Frame>
  );
}

function InstallCallout() {
  const mobileOS = getMobileOS();
  if (!mobileOS) {
    return;
  }

  const Instructions = instructionsByOs[mobileOS];

  return (
    <Callout left={<AppIcon className="mr-2" />} onClose={closeCallout}>
      <Text size={14} className="mb-1">
        Get the Passkeys app
      </Text>
      <Instructions />
    </Callout>
  );
}

export default InstallCallout;
